import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.55, delay, ease: [0.16, 1, 0.3, 1] }} className={className}>
    {children}
  </motion.div>
);

export const SectionHead = ({ num, eyebrow, title, sub, dark = false }) => (
  <Reveal className="max-w-2xl">
    <p className="font-mono text-xs font-semibold tracking-[0.2em] uppercase text-[#EA580C]">{num} / {eyebrow}</p>
    <h2 className={`font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${dark ? "text-white" : "text-[#0F172A]"}`}>{title}</h2>
    {sub && <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>{sub}</p>}
  </Reveal>
);
